import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { Schedule } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

interface Props {
  start_date_and_time: string;
  end_date_and_time: string;
}

const useSchedulesQuery = ({
  start_date_and_time,
  end_date_and_time,
}: Props) => {
  const branch = useBranchId();

  const query = useQuery<Schedule[]>({
    queryKey: ["schedules", branch, start_date_and_time, end_date_and_time],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/personnel/all/record/${branch}`, {
        params: {
          start_date_and_time,
          end_date_and_time,
        },
      }),
  });

  return query;
};

export default useSchedulesQuery;
